<app-hr-page-header
  [heading]="headingCompanies"
  [searchPlaceholder]="'Search companies'"
  [addButtonText]="'Add Company'"
  [exportButtonText]="'Export'"
  [showFilterIcon]="true"
  [initialSearchQuery]="searchQuery"
  (searchInput)="onSearchInput($event)"
  (addClick)="addCompany()"
  (exportClick)="exportCompanies()"
  (filterClick)="openFilterDialog()"
></app-hr-page-header>

<div class="hr-table-container">
  <div class="table-responsive" *ngIf="companylist && companylist.length > 0">
    <table class="table" id="emp_expense">
      <thead>
        <tr>
          <th>ID</th>
          <th>Company Name</th>
          <!-- <th>Code</th> -->
          <th>Type</th>
          <!-- <th>Action</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cmp of companylist; let i = index">
          <td>{{ cmp.company_id }}</td>
          <td>{{ cmp.name | titlecase }}</td>
          <!-- <td>{{ cmp.code }}</td> -->
          <td>{{ cmp.company_type}}</td>
          <!-- <td>
            <span class="action-link" (click)="editCompany(cmp)">
              Edit
               <img class="arrow-image" src="../../../assets/images/arrows.svg" alt="">
             
            </span>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data State -->
  <div class="no-data-container" *ngIf="!companylist || companylist.length === 0">
    <div class="no-data-content">
      <img src="/assets/images/no-data.svg" alt="No data" class="no-data-icon">
      <p class="no-data-message">No Companies found</p>
    </div>
  </div>
</div>

<!-- Pagination Controls -->
<!-- <div class="pagination-controls" 
     *ngIf="companylist && companylist.length > 0"
     style="margin-top: 16px; display: flex; justify-content: flex-end; align-items: center;">
  <mat-paginator
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[10]"
    (page)="handlePageChange($event.pageIndex + 1)">
  </mat-paginator>
</div> -->
